export default __webpack_public_path__ + "static/PXPVideoTheme-b630f2d06255555b40f5ed309d8f1290.mp4";